import ConnectErrorRecord from "@infinode/records/ConnectErrorRecord";
import { call, put, takeEvery } from "@redux-saga/core/effects";
import { CONNECT_ERRORS } from "src/infinode/constants/connect";

const getHeader = token => {
  let header = {
    "Content-Type": "application/json",
    // 'Content-Type': 'application/x-www-form-urlencoded',
    "Access-Control-Allow-Origin": "*"
  };
  if (token) {
    header.Authorization = `Bearer ${token}`;
  }
  return header;
};

const getPostRequestInfo = (body, token) => ({
  method: "POST", // *GET, POST, PUT, DELETE, etc.
  mode: "cors", // no-cors, *cors, same-origin
  cache: "no-cache", // *default, no-cache, reload, force-cache, only-if-cached
  credentials: "omit", // include, *same-origin, omit
  headers: getHeader(token),
  redirect: "follow", // manual, *follow, error
  referrerPolicy: "no-referrer", // no-referrer, *no-referrer-when-downgrade, origin, origin-when-cross-origin, same-origin, strict-origin, strict-origin-when-cross-origin, unsafe-url
  body: JSON.stringify(body)
});

const getGetRequestInfo = token => ({
  method: "GET",
  headers: getHeader(token)
});

const getDeleteRequestInfo = token => ({
  method: "DELETE",
  headers: getHeader(token)
});

const getPutRequestInfo = (body, token) => ({
  method: "PUT", // *GET, POST, PUT, DELETE, etc.
  mode: "cors", // no-cors, *cors, same-origin
  cache: "no-cache", // *default, no-cache, reload, force-cache, only-if-cached
  credentials: "omit", // include, *same-origin, omit
  headers: getHeader(token),
  redirect: "follow", // manual, *follow, error
  referrerPolicy: "no-referrer", // no-referrer, *no-referrer-when-downgrade, origin, origin-when-cross-origin, same-origin, strict-origin, strict-origin-when-cross-origin, unsafe-url
  body: JSON.stringify(body)
});

const getErrorFromResponseBody = responseBody =>
  ConnectErrorRecord({
    title: responseBody.title,
    errorCode: responseBody.status,
    message: responseBody.detail
  });

const getErrorFromResponse = response => {
  const error = CONNECT_ERRORS[response.status];
  return error;
};

const getRequestGeneratorFunction = (actionTypeRequest, actionTypeError, fetchFunction, onSuccess) => {
  return function* () {
    yield takeEvery(actionTypeRequest, function* (params) {
      try {
        const result = yield call(fetchFunction, params);
        if (result.ok) {
          const resultBody = yield result.json();
          const success = yield onSuccess(resultBody, params);
          if (!success) {
            yield put({
              type: actionTypeError,
              error: getErrorFromResponseBody(resultBody)
            });
          }
        } else {
          yield put({
            type: actionTypeError,
            error: getErrorFromResponse(result)
          });
        }
      } catch (error) {
        console.log(error);
        yield put({
          type: actionTypeError,
          error
        });
      }
    });
  };
};

export {
  getPostRequestInfo,
  getGetRequestInfo,
  getDeleteRequestInfo,
  getErrorFromResponseBody,
  getPutRequestInfo,
  getRequestGeneratorFunction
};
